import * as React from "react";
import { Grid, makeStyles, Container, Button } from "@material-ui/core";
import Login from "../components/Login";
import { UserContext } from "../context/UserContext";
import Footer from "../components/Footer";
import SignUp from "../components/SignUp";
import VerifyEmail from "../components/VerifyEmail";
import ForgotPassword from "../components/ForgotPassword";
import { useHistory, Redirect } from "react-router-dom";

export enum HomeStates {
  Create = "CREATE",
  Login = "LOGIN",
  ForgotPassword = "FORGOT_PASSWORD",
  SSO = "SSO",
}

interface IProps {
  initialHomeState: string;
  loadingUser: boolean;
}

export default function HomePage(props: IProps) {
  const { initialHomeState, loadingUser } = props;
  const user = React.useContext(UserContext);
  const classes = useStyles();
  const allowSignUp = process.env.REACT_APP_ALLOW_SIGN_UP;
  const history = useHistory();

  let rightPanel;
  if (!user.authenticated) {
    switch (initialHomeState) {
      case HomeStates.Login:
        rightPanel = (
          <div>
            <Login loadingUser={loadingUser} />
            {allowSignUp === "true" ? (
              <div className={classes.createContainer}>
                <Button
                  onClick={() => history.push("/create")}
                  className={classes.createButton}
                >
                  Don't have an account? Create one now!
                </Button>
              </div>
            ) : null}
          </div>
        );
        break;
      case HomeStates.Create:
        rightPanel = (
          <div>
            {allowSignUp === "true" ? (
              <>
                <SignUp />
                <div className={classes.createContainer}>
                  <Button
                    onClick={() => history.push("/login")}
                    className={classes.createButton}
                  >
                    Already have an account? Log in now!
                  </Button>
                </div>
              </>
            ) : null}
          </div>
        );
        break;
      case HomeStates.ForgotPassword:
        rightPanel = (
          <div>
            <ForgotPassword />
            {allowSignUp === "true" ? (
              <div className={classes.createContainer}>
                <Button
                  onClick={() => history.push("/create")}
                  className={classes.createButton}
                >
                  Don't have an account? Create one now!
                </Button>
              </div>
            ) : null}
          </div>
        );
        break;
    }
  } else if (user.authenticated && !user.profile.email_verified) {
    rightPanel = (
      <div>
        <VerifyEmail />
      </div>
    );
  }

  return (
    <>
      {user.authenticated && user.profile.email_verified ? (
        <Redirect to="/" />
      ) : (
        <div className="full-height">
          <div className={classes.wrapper}>
            <Container maxWidth="lg" className={classes.content}>
              <Grid
                container
                spacing={2}
                alignItems="center"
                className={classes.container}
              >
                {/* <Grid item md={7} xs={12}>
                  <h1 className={classes.mainTitle}>
                    Less data management
                    <br />
                    More peace of mind
                  </h1>
                </Grid> */}
                <Grid item md={3} xs={12}></Grid>
                <Grid item md={6} xs={12}>
                  {rightPanel}
                </Grid>
                <Grid item md={3} xs={12}></Grid>
              </Grid>
            </Container>
            <Footer />
          </div>
        </div>
      )}
    </>
  );
}

const useStyles = makeStyles({
  wrapper: {
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundImage: `url("./empathihr_blue_bg.jpg")`,
    backgroundSize: "cover",
  },
  content: {
    flex: "1 0 auto",
    display: "flex",
  },
  footer: { flexShrink: 0 },
  container: {
    paddingTop: 40,
    paddingBottom: 20,
  },
  mainTitle: {
    fontSize: 50,
    fontWeight: 700,
    lineSpacing: 63,
    color: "#fff",
    paddingBottom: 120,
  },
  createContainer: {
    marginTop: 16,
    textAlign: "center",
  },
  createButton: {
    textTransform: "none",
    color: "#fff",
    fontWeight: 500,
  },
});
